import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { useNavigate } from 'react-router-dom';
import { ChevronRight, Filter } from 'lucide-react';

const Timecard: React.FC = () => {
  const timecardData = useSelector((state: RootState) => state.Emp_Timecard.data);
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white w-full max-w-md mx-auto overflow-y-auto">
      {/* Header with Timecard Title, Records, and Filter Icon */}
      <div className="bg-white shadow p-4 flex items-center justify-between">
        <span className="font-semibold text-lg">Timecard</span>
        <div className="flex items-center gap-2">
          <button onClick={() => navigate('/test-Emp_TimecardFilter')}>
            {/* <MdOutlineFilterAlt size={24} className="text-gray-600" /> */}
            <Filter size={24} className="text-gray-600" />
          </button>
        </div>
      </div>

      {/* Summary and Records Tabs */}
      <div className="flex justify-between bg-white shadow mt-2 p-2">
        <span className="font-medium text-gray-500">SUMMARY</span>
        <span className="font-medium border-b-2" style={{ borderColor: '#2196F3' }}>RECORDS</span>
      </div>

      {/* Pay Period Section */}
      <div className="flex justify-start bg-white shadow mt-2 p-2 font-medium">
        Payperiod : Feb 03 - Feb 10
      </div>

      {/* Timecard Records */}
      <div className="flex-1 overflow-y-auto mt-2 space-y-2">
        {timecardData.map((log, index) => (
          <div key={index} className="flex items-center bg-white p-2 rounded shadow-md">
            <div className="w-10 text-center font-bold text-gray-700 text-xl">{log.date}</div>
            <div className="w-10 text-center text-sm text-gray-500">{log.month}<br />{log.day}</div>
            <div className="w-1 bg-green-500 h-10 mx-2"></div>
            <div className="flex-1">
              <p className="font-semibold text-gray-800 text-sm">{log.inTime} - {log.outTime || 'NA'}</p>
              {log.hoursWorked && <p className="text-gray-500 text-xs">{log.hoursWorked}</p>}
            </div>
            <button 
              onClick={() => navigate(`/test-Emp_TimecardDetails/${log.date}/${log.inTime}`)} 
              className="text-black font-bold"
            >
              <ChevronRight/>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Timecard;


